const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: The Laplace Transform — Time vs s-domain ──────────
function DiagramLaplace() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  // Time-domain: exponential decay curve
  const tdPts = [];
  for (let i = 0; i <= 50; i++) {
    const t = i / 50;
    tdPts.push([30 + t * (PW - 50), 280 - Math.exp(-t * 3.5) * 200]);
  }

  // s-domain: magnitude of 1/(s+a) along imaginary axis (frequency response sketch)
  const sdPts = [];
  for (let i = 0; i <= 60; i++) {
    const w = i / 60;
    const mag = 1 / Math.sqrt(w * w * 36 + 1);
    sdPts.push([PW + 50 + w * (PW - 60), 280 - mag * 200]);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Laplace Transform — Bridging Time Domain and s-Domain</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="axArrow" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888" />
          </marker>
          <marker id="redArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" />
          </marker>
        </defs>

        {/* Panel 1: Time domain */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">Time Domain — f(t)</text>

        {/* Axes */}
        <line x1={28} y1={285} x2={PW - 10} y2={285} stroke="#888" strokeWidth="1.5" markerEnd="url(#axArrow)" />
        <line x1={28} y1={285} x2={28} y2={60} stroke="#888" strokeWidth="1.5" markerEnd="url(#axArrow)" />
        <text x={PW - 12} y={298} fontSize="11" fill="#555">t</text>
        <text x={16} y={58} fontSize="11" fill="#555">f(t)</text>

        {/* Curve: e^{-at} */}
        <polyline points={tdPts.map(([x, y]) => `${x},${y}`).join(' ')} fill="none" stroke="#c0392b" strokeWidth="2.5" />
        <text x={80} y={90} fontSize="12" fill="#c0392b" fontWeight="700">f(t) = e⁻ᵃᵗ</text>

        {/* Annotation boxes */}
        <rect x={20} y={160} width={PW - 30} height={54} rx={3} fill="#fff5f5" stroke="#f0cece" />
        <text x={28} y={176} fontSize="11" fill="#7B0D0D" fontWeight="700">Laplace Transform:</text>
        <text x={28} y={193} fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">F(s) = ∫₀^∞ f(t)·e⁻ˢᵗ dt</text>
        <text x={28} y={208} fontSize="10" fill="#555">s = σ + jω  (complex frequency)</text>

        <rect x={20} y={222} width={PW - 30} height={34} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1" />
        <text x={28} y={237} fontSize="11" fill="#7B0D0D" fontWeight="700">Inverse: f(t) = L⁻¹{"{F(s)}"} via partial fractions</text>
        <text x={28} y={251} fontSize="10" fill="#555">Converts algebraic s-domain back to time-domain solution</text>

        {/* Big arrow between panels */}
        <rect x={PW - 8} y={H / 2 - 28} width={46} height={56} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5" />
        <text x={PW + 14} y={H / 2 - 8} textAnchor="middle" fontSize="10" fill="#7B0D0D" fontWeight="700">L{ '{·}' }</text>
        <line x1={PW - 4} y1={H / 2 + 4} x2={PW + 34} y2={H / 2 + 4} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#redArr)" />
        <line x1={PW + 30} y1={H / 2 - 16} x2={PW - 4} y2={H / 2 - 16} stroke="#2E75B6" strokeWidth="1.5" markerEnd="url(#axArrow)" />
        <text x={PW + 14} y={H / 2 + 24} textAnchor="middle" fontSize="9" fill="#2E75B6">L⁻¹</text>

        {/* Panel 2: s-domain */}
        <rect x={PW + 40} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 40 + PW / 2} y={30} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">s-Domain — F(s) (magnitude along jω axis)</text>

        {/* Axes */}
        <line x1={PW + 48} y1={285} x2={W - 14} y2={285} stroke="#888" strokeWidth="1.5" markerEnd="url(#axArrow)" />
        <line x1={PW + 48} y1={285} x2={PW + 48} y2={60} stroke="#888" strokeWidth="1.5" markerEnd="url(#axArrow)" />
        <text x={W - 16} y={298} fontSize="11" fill="#555">ω</text>
        <text x={PW + 36} y={58} fontSize="11" fill="#555">|F|</text>

        {/* Curve: magnitude of 1/(jw+a) */}
        <polyline points={sdPts.map(([x, y]) => `${x},${y}`).join(' ')} fill="none" stroke="#2E75B6" strokeWidth="2.5" />
        <text x={PW + 80} y={92} fontSize="12" fill="#2E75B6" fontWeight="700">F(s) = 1/(s+a)</text>

        {/* -3dB point */}
        <line x1={PW + 48} y1={280 - 141} x2={PW + 100} y2={280 - 141} stroke="#e07b00" strokeWidth="1.2" strokeDasharray="4,3" />
        <text x={PW + 104} y={280 - 137} fontSize="10" fill="#e07b00">−3 dB (ω=a)</text>

        {/* Pole label */}
        <rect x={PW + 50} y={100} width={PW - 20} height={42} rx={3} fill="#fff5f5" stroke="#f0cece" />
        <text x={PW + 58} y={117} fontSize="11" fill="#7B0D0D" fontWeight="700">Pole at s = −a  (σ = −a, ω = 0)</text>
        <text x={PW + 58} y={133} fontSize="10" fill="#555">Pole on negative real axis → stable, exponential decay in time</text>

        <rect x={PW + 50} y={222} width={PW - 20} height={56} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1" />
        <text x={PW + 58} y={238} fontSize="11" fill="#7B0D0D" fontWeight="700">Key insight:</text>
        <text x={PW + 58} y={254} fontSize="10" fill="#555">Differentiation → multiply by s</text>
        <text x={PW + 58} y={268} fontSize="10" fill="#555">Integration → divide by s</text>
        <text x={PW + 58} y={282} fontSize="10" fill="#555">ODEs → algebraic equations in s</text>
      </svg>
      <div style={S.dCaption}>The Laplace transform converts time-domain differential equations into algebraic equations in the complex variable s = σ + jω. This transforms the hard problem of solving ODEs into the easier problem of manipulating rational polynomials. The inverse Laplace transform recovers the time-domain solution via partial fraction expansion.</div>
    </div>
  );
}

// ── Diagram 2: Transfer Function Block Diagram ────────────────────
function DiagramBlockDiagram() {
  const W = 900, H = 310;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Transfer Function Block Diagrams — Open-Loop and Closed-Loop</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="blkArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" />
          </marker>
          <marker id="blkArrB" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#2E75B6" />
          </marker>
        </defs>

        {/* ── Row 1: Open-loop ── */}
        <text x={10} y={22} fontSize="13" fill="#7B0D0D" fontWeight="700">Open-Loop System</text>

        {/* Input */}
        <text x={18} y={60} fontSize="12" fill="#555">U(s)</text>
        <line x1={55} y1={55} x2={100} y2={55} stroke="#c0392b" strokeWidth="2" markerEnd="url(#blkArr)" />

        {/* G(s) block */}
        <rect x={100} y={35} width={130} height={40} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2" />
        <text x={165} y={60} textAnchor="middle" fontSize="14" fill="#7B0D0D" fontWeight="700">G(s)</text>
        <text x={165} y={74} textAnchor="middle" fontSize="9" fill="#c0392b">Plant / System</text>

        <line x1={230} y1={55} x2={310} y2={55} stroke="#c0392b" strokeWidth="2" markerEnd="url(#blkArr)" />
        <text x={316} y={60} fontSize="12" fill="#555">Y(s)</text>

        {/* Transfer function formula */}
        <rect x={360} y={28} width={240} height={54} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5" />
        <text x={480} y={47} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Open-loop TF:</text>
        <text x={480} y={65} textAnchor="middle" fontSize="13" fill="#c0392b" fontFamily="'Courier New',monospace">G(s) = Y(s) / U(s)</text>
        <text x={480} y={78} textAnchor="middle" fontSize="10" fill="#555">= N(s) / D(s)  (ratio of polynomials in s)</text>

        {/* Right legend */}
        <rect x={630} y={18} width={258} height={H - 28} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={759} y={38} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Block Algebra Rules</text>
        {[
          { y: 48, bg: '#fff5f5', bc: '#c0392b', lines: ['Series: G₁(s)·G₂(s)', 'Multiply transfer functions'] },
          { y: 96, bg: '#FEF0F0', bc: '#e07b00', lines: ['Parallel: G₁(s) + G₂(s)', 'Add transfer functions'] },
          { y: 144, bg: '#eaf3ff', bc: '#2E75B6', lines: ['Closed-loop: G/(1+GH)', 'Feedback reduces gain'] },
          { y: 192, bg: '#fff5f5', bc: '#c0392b', lines: ['Move summing junction:', 'Divide branch by G(s)'] },
          { y: 240, bg: '#FEF0F0', bc: '#e07b00', lines: ['Move pick-off point:', 'Multiply branch by G(s)'] },
        ].map(({ y, bg, bc, lines }) => (
          <g key={y}>
            <rect x={636} y={y} width={246} height={44} rx={3} fill={bg} stroke={bc} strokeWidth="1" />
            {lines.map((l, i) => <text key={i} x={644} y={y + 16 + i * 15} fontSize="11" fill="#333">{l}</text>)}
          </g>
        ))}

        {/* ── Row 2: Closed-loop ── */}
        <text x={10} y={130} fontSize="13" fill="#7B0D0D" fontWeight="700">Closed-Loop System (Unity Feedback)</text>

        {/* Summing junction */}
        <circle cx={80} cy={185} r={14} fill="#fff" stroke="#c0392b" strokeWidth="2" />
        <text x={80} y={190} textAnchor="middle" fontSize="14" fill="#c0392b" fontWeight="700">Σ</text>
        <text x={55} y={182} fontSize="11" fill="#555">R(s)</text>
        <line x1={20} y1={185} x2={64} y2={185} stroke="#c0392b" strokeWidth="2" markerEnd="url(#blkArr)" />
        <text x={88} y={172} fontSize="11" fill="#2E75B6">+</text>
        <text x={72} y={210} fontSize="11" fill="#c0392b">−</text>

        {/* E(s) */}
        <line x1={94} y1={185} x2={130} y2={185} stroke="#c0392b" strokeWidth="2" markerEnd="url(#blkArr)" />
        <text x={108} y={178} fontSize="10" fill="#555">E(s)</text>

        {/* Controller C(s) */}
        <rect x={130} y={165} width={110} height={40} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2" />
        <text x={185} y={188} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">C(s)</text>
        <text x={185} y={200} textAnchor="middle" fontSize="9" fill="#c0392b">Controller</text>

        <line x1={240} y1={185} x2={270} y2={185} stroke="#c0392b" strokeWidth="2" markerEnd="url(#blkArr)" />

        {/* Plant G(s) */}
        <rect x={270} y={165} width={110} height={40} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2" />
        <text x={325} y={188} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">G(s)</text>
        <text x={325} y={200} textAnchor="middle" fontSize="9" fill="#c0392b">Plant</text>

        <line x1={380} y1={185} x2={430} y2={185} stroke="#c0392b" strokeWidth="2" markerEnd="url(#blkArr)" />
        <text x={436} y={182} fontSize="12" fill="#555">Y(s)</text>

        {/* Feedback path */}
        <line x1={420} y1={185} x2={420} y2={240} stroke="#2E75B6" strokeWidth="2" />
        <line x1={420} y1={240} x2={80} y2={240} stroke="#2E75B6" strokeWidth="2" />
        <line x1={80} y1={240} x2={80} y2={201} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#blkArrB)" />
        <text x={250} y={256} textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">Feedback path H(s) = 1 (unity)</text>

        {/* Closed-loop formula */}
        <rect x={460} y={155} width={152} height={68} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5" />
        <text x={536} y={173} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">Closed-loop TF:</text>
        <text x={536} y={191} textAnchor="middle" fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">T(s) = C·G</text>
        <text x={536} y={207} textAnchor="middle" fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">    1+C·G</text>
        <line x1={468} y1={197} x2={606} y2={197} stroke="#c0392b" strokeWidth="1.5" />
        <text x={536} y={220} textAnchor="middle" fontSize="10" fill="#555">Characteristic eq: 1+C(s)G(s)=0</text>
      </svg>
      <div style={S.dCaption}>Block diagrams represent signal flow through a system. Each block contains the transfer function of a component. Series blocks multiply; parallel blocks add. The fundamental closed-loop transfer function T(s) = CG/(1+CGH) captures how feedback reshapes the input-output relationship. The denominator 1+CGH = 0 is the characteristic equation whose roots (poles) determine stability.</div>
    </div>
  );
}

// ── Diagram 3: Poles and Zeros in the s-Plane ────────────────────
function DiagramPoleZero() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  // Helper to draw x (pole) and o (zero)
  const cx = 10 + PW / 2, cy = 160;
  const scale = 48;

  const poles = [
    { re: -1, im: 2, label: 'p₁' },
    { re: -1, im: -2, label: 'p₂' },
    { re: -3, im: 0, label: 'p₃' },
  ];
  const zeros = [
    { re: -0.5, im: 0, label: 'z₁' },
  ];

  // Unstable poles panel
  const cx2 = PW + 40 + PW / 2, cy2 = 160;
  const unstablePoles = [
    { re: 1, im: 1.5, label: 'p₁', col: '#c0392b' },
    { re: 1, im: -1.5, label: 'p₂', col: '#c0392b' },
    { re: -2, im: 0, label: 'p₃', col: '#27ae60' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Pole-Zero Map in the s-Plane — Stability and Response Shape</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="pzArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Stable system */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Stable System — All Poles in Left Half-Plane</text>

        {/* Axes */}
        <line x1={10 + 20} y1={cy} x2={10 + PW - 10} y2={cy} stroke="#ccc" strokeWidth="1.5" markerEnd="url(#pzArr)" />
        <line x1={cx} y1={H - 30} x2={cx} y2={20} stroke="#ccc" strokeWidth="1.5" markerEnd="url(#pzArr)" />
        <text x={10 + PW - 12} y={cy + 14} fontSize="10" fill="#888">σ (Re)</text>
        <text x={cx + 4} y={24} fontSize="10" fill="#888">jω (Im)</text>

        {/* Shading: stable LHP */}
        <rect x={10 + 20} y={20} width={cx - 10 - 20} height={H - 50} fill="#f0fff4" opacity="0.5" />
        <text x={10 + 40} y={H - 34} fontSize="10" fill="#27ae60" opacity="0.7">Stable region (Re &lt; 0)</text>

        {/* Grid lines */}
        {[-2, -1, 1, 2].map(v => (
          <g key={v}>
            <line x1={cx + v * scale} y1={cy - 4} x2={cx + v * scale} y2={cy + 4} stroke="#bbb" strokeWidth="1" />
            <text x={cx + v * scale} y={cy + 14} textAnchor="middle" fontSize="9" fill="#aaa">{v}</text>
          </g>
        ))}
        {[-3, -2, -1, 1, 2, 3].map(v => (
          <g key={v}>
            <line x1={cx - 4} y1={cy - v * scale} x2={cx + 4} y2={cy - v * scale} stroke="#bbb" strokeWidth="1" />
            <text x={cx - 10} y={cy - v * scale + 4} textAnchor="end" fontSize="9" fill="#aaa">{v}j</text>
          </g>
        ))}

        {/* Poles (×) */}
        {poles.map(({ re, im, label }) => {
          const px = cx + re * scale, py = cy - im * scale;
          return (
            <g key={label}>
              <line x1={px - 8} y1={py - 8} x2={px + 8} y2={py + 8} stroke="#c0392b" strokeWidth="2.5" />
              <line x1={px + 8} y1={py - 8} x2={px - 8} y2={py + 8} stroke="#c0392b" strokeWidth="2.5" />
              <text x={px + 10} y={py - 6} fontSize="11" fill="#c0392b" fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Zeros (○) */}
        {zeros.map(({ re, im, label }) => {
          const px = cx + re * scale, py = cy - im * scale;
          return (
            <g key={label}>
              <circle cx={px} cy={py} r={7} fill="none" stroke="#2E75B6" strokeWidth="2.5" />
              <text x={px + 10} y={py - 6} fontSize="11" fill="#2E75B6" fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Legend */}
        <line x1={20} y1={H - 55} x2={32} y2={H - 43} stroke="#c0392b" strokeWidth="2} " />
        <line x1={32} y1={H - 55} x2={20} y2={H - 43} stroke="#c0392b" strokeWidth="2" />
        <text x={38} y={H - 44} fontSize="10" fill="#c0392b">= Pole (×)  root of denominator</text>
        <circle cx={22} cy={H - 30} r={6} fill="none" stroke="#2E75B6" strokeWidth="2" />
        <text x={38} y={H - 26} fontSize="10" fill="#2E75B6">= Zero (○)  root of numerator</text>

        {/* Panel 2: Stability regions */}
        <rect x={PW + 40} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={cx2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Stability Regions and Time-Domain Behaviour</text>

        {/* Axes */}
        <line x1={PW + 50} y1={cy2} x2={W - 14} y2={cy2} stroke="#ccc" strokeWidth="1.5" markerEnd="url(#pzArr)" />
        <line x1={cx2} y1={H - 30} x2={cx2} y2={20} stroke="#ccc" strokeWidth="1.5" markerEnd="url(#pzArr)" />
        <text x={W - 16} y={cy2 + 14} fontSize="10" fill="#888">σ</text>
        <text x={cx2 + 4} y={24} fontSize="10" fill="#888">jω</text>

        {/* LHP green shade */}
        <rect x={PW + 50} y={20} width={cx2 - PW - 50} height={H - 50} fill="#f0fff4" opacity="0.4" />
        {/* RHP red shade */}
        <rect x={cx2} y={20} width={W - 14 - cx2} height={H - 50} fill="#fff0f0" opacity="0.4" />

        {/* Vertical jw axis label */}
        <line x1={cx2} y1={20} x2={cx2} y2={H - 30} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="6,3" />
        <text x={cx2 + 2} y={H - 32} fontSize="9" fill="#c0392b">Im axis = marginally stable</text>

        {/* Region labels */}
        <text x={PW + 60} y={50} fontSize="11" fill="#27ae60" fontWeight="700">STABLE</text>
        <text x={PW + 60} y={65} fontSize="9" fill="#27ae60">decaying transients</text>
        <text x={cx2 + 10} y={50} fontSize="11" fill="#c0392b" fontWeight="700">UNSTABLE</text>
        <text x={cx2 + 10} y={65} fontSize="9" fill="#c0392b">growing transients</text>

        {/* Poles with annotations */}
        {unstablePoles.map(({ re, im, label, col }) => {
          const px = cx2 + re * scale, py = cy2 - im * scale;
          return (
            <g key={label}>
              <line x1={px - 8} y1={py - 8} x2={px + 8} y2={py + 8} stroke={col} strokeWidth="2.5" />
              <line x1={px + 8} y1={py - 8} x2={px - 8} y2={py + 8} stroke={col} strokeWidth="2.5" />
              <text x={px + 10} y={py - 4} fontSize="10" fill={col} fontWeight="700">{label}</text>
            </g>
          );
        })}

        {/* Annotations */}
        {[
          { x: cx2 - 110, y: 110, text: 'Complex pair → oscillatory', col: '#2E75B6' },
          { x: cx2 - 140, y: 200, text: 'Real pole → pure exponential', col: '#27ae60' },
          { x: cx2 + 15, y: 110, text: 'RHP complex → growing osc.', col: '#c0392b' },
        ].map(({ x, y, text, col }) => (
          <text key={text} x={x} y={y} fontSize="9.5" fill={col} fontStyle="italic">{text}</text>
        ))}

        <rect x={PW + 50} y={H - 64} width={PW - 16} height={40} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1" />
        <text x={PW + 58} y={H - 49} fontSize="11" fill="#7B0D0D" fontWeight="700">Stability: ALL poles must have Re(s) &lt; 0</text>
        <text x={PW + 58} y={H - 34} fontSize="10" fill="#555">Marginal: poles on jω axis (Re=0) — sustained oscillation</text>
      </svg>
      <div style={S.dCaption}>The s-plane pole-zero map is the single most informative diagram for a linear system. Poles (×) are roots of the denominator — they determine stability and transient shape. Zeros (○) are roots of the numerator — they shape the frequency of response. All poles in the left half-plane (Re &lt; 0) → stable. Any pole in the right half-plane → unstable.</div>
    </div>
  );
}

// ── Diagram 4: Bode Plot — Magnitude and Phase ───────────────────
function DiagramBode() {
  const W = 900, H = 360;
  const padL = 58, padR = 20, padT = 30, plotH = 130;

  // First-order system G(jw) = 1/(1+jw*tau), tau=1, so corner freq = 1
  const nPts = 80;
  const wVals = [];
  for (let i = 0; i < nPts; i++) {
    wVals.push(Math.pow(10, -2 + i * 4 / (nPts - 1)));
  }

  const magDB = wVals.map(w => -10 * Math.log10(1 + w * w));
  const phDeg = wVals.map(w => -Math.atan(w) * 180 / Math.PI);

  // Asymptotic approximation
  const asymMag = wVals.map(w => w < 1 ? 0 : -20 * Math.log10(w));

  const mapX = w => padL + (Math.log10(w) + 2) / 4 * (W - padL - padR);
  const mapMagY = db => padT + plotH - (db + 40) / 40 * plotH;
  const mapPhY = db => padT + plotH * 2 + 30 + (db + 90) / 90 * plotH;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Bode Plot — Frequency Response of G(s) = 1/(1+τs), τ = 1 sec</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="bodeArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888" />
          </marker>
        </defs>

        {/* ── Magnitude plot ── */}
        <text x={W / 2} y={padT - 8} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Magnitude (dB)</text>

        {/* Grid */}
        {[-40, -20, -10, 0].map(db => {
          const y = mapMagY(db);
          return (
            <g key={db}>
              <line x1={padL} y1={y} x2={W - padR} y2={y} stroke="#f0cece" strokeWidth={db === 0 ? 1.5 : 1} />
              <text x={padL - 4} y={y + 4} textAnchor="end" fontSize="10" fill="#888">{db}</text>
            </g>
          );
        })}

        {/* Frequency grid */}
        {[0.01, 0.1, 1, 10, 100].map(w => {
          const x = mapX(w);
          return (
            <g key={w}>
              <line x1={x} y1={padT} x2={x} y2={padT + plotH} stroke="#f0cece" strokeWidth="1" />
              <text x={x} y={padT + plotH + 12} textAnchor="middle" fontSize="10" fill="#888">{w}</text>
            </g>
          );
        })}

        {/* Asymptotic (dashed) */}
        <polyline
          points={wVals.map((w, i) => `${mapX(w)},${mapMagY(asymMag[i])}`).join(' ')}
          fill="none" stroke="#e07b00" strokeWidth="1.8" strokeDasharray="6,4"
        />

        {/* Actual curve */}
        <polyline
          points={wVals.map((w, i) => `${mapX(w)},${mapMagY(magDB[i])}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"
        />

        {/* -3dB annotation */}
        {(() => {
          const x = mapX(1), y = mapMagY(-3.01);
          return (
            <>
              <circle cx={x} cy={y} r={4} fill="#c0392b" />
              <line x1={x} y1={y} x2={x + 60} y2={y - 20} stroke="#c0392b" strokeWidth="1" strokeDasharray="3,2" />
              <text x={x + 62} y={y - 22} fontSize="10" fill="#c0392b" fontWeight="700">−3 dB corner (ω=1/τ)</text>
            </>
          );
        })()}

        {/* Labels */}
        <text x={padL + 10} y={mapMagY(0) - 4} fontSize="10" fill="#e07b00">Asymptote (−20 dB/dec slope)</text>
        <text x={padL + 10} y={mapMagY(-25)} fontSize="10" fill="#c0392b">Actual response</text>

        {/* Axes */}
        <line x1={padL} y1={padT} x2={padL} y2={padT + plotH} stroke="#888" strokeWidth="1.5" />
        <line x1={padL} y1={padT + plotH} x2={W - padR} y2={padT + plotH} stroke="#888" strokeWidth="1.5" />

        {/* ── Phase plot ── */}
        <text x={W / 2} y={padT + plotH + 22} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Phase (°)</text>

        {[-90, -45, 0].map(deg => {
          const y = mapPhY(deg);
          return (
            <g key={deg}>
              <line x1={padL} y1={y} x2={W - padR} y2={y} stroke="#f0cece" strokeWidth={deg === 0 ? 1.5 : 1} />
              <text x={padL - 4} y={y + 4} textAnchor="end" fontSize="10" fill="#888">{deg}°</text>
            </g>
          );
        })}

        {[0.01, 0.1, 1, 10, 100].map(w => {
          const x = mapX(w);
          return <line key={w} x1={x} y1={padT + plotH + 30} x2={x} y2={padT + plotH * 2 + 30} stroke="#f0cece" strokeWidth="1" />;
        })}

        <polyline
          points={wVals.map((w, i) => `${mapX(w)},${mapPhY(phDeg[i])}`).join(' ')}
          fill="none" stroke="#2E75B6" strokeWidth="2.5"
        />

        {/* -45° annotation */}
        {(() => {
          const x = mapX(1), y = mapPhY(-45);
          return (
            <>
              <circle cx={x} cy={y} r={4} fill="#2E75B6" />
              <line x1={x} y1={y} x2={x + 60} y2={y + 20} stroke="#2E75B6" strokeWidth="1" strokeDasharray="3,2" />
              <text x={x + 62} y={y + 22} fontSize="10" fill="#2E75B6" fontWeight="700">−45° at corner freq</text>
            </>
          );
        })()}

        {/* Phase axes */}
        <line x1={padL} y1={padT + plotH + 30} x2={padL} y2={padT + plotH * 2 + 30} stroke="#888" strokeWidth="1.5" />
        <line x1={padL} y1={padT + plotH * 2 + 30} x2={W - padR} y2={padT + plotH * 2 + 30} stroke="#888" strokeWidth="1.5" />
        <text x={W / 2} y={H - 4} textAnchor="middle" fontSize="10" fill="#888">Frequency ω (rad/s) — log scale</text>

        {/* Legend */}
        <line x1={W - 200} y1={padT + 14} x2={W - 180} y2={padT + 14} stroke="#c0392b" strokeWidth="2.5" />
        <text x={W - 176} y={padT + 18} fontSize="10" fill="#c0392b">Exact</text>
        <line x1={W - 130} y1={padT + 14} x2={W - 110} y2={padT + 14} stroke="#e07b00" strokeWidth="1.8" strokeDasharray="5,3" />
        <text x={W - 106} y={padT + 18} fontSize="10" fill="#e07b00">Asymptote</text>
      </svg>
      <div style={S.dCaption}>A Bode plot shows magnitude (in dB) and phase (in degrees) vs. frequency on a log scale. For a first-order system the magnitude rolls off at −20 dB/decade above the corner frequency ω = 1/τ, and the phase shifts from 0° to −90°. Asymptotic straight-line approximations make Bode plots easy to sketch by hand and are accurate everywhere except within a decade of the corner frequency.</div>
    </div>
  );
}

// ── Diagram 5: Nyquist Plot ───────────────────────────────────────
function DiagramNyquist() {
  const W = 900, H = 330;
  const PW = (W - 30) / 2;

  // G(jw) = 1/((jw+1)(jw/2+1))  — second-order
  const nPts = 120;
  const wRange = [];
  for (let i = 0; i <= nPts; i++) wRange.push(i / nPts * 8);

  const pts = wRange.map(w => {
    const d1r = 1, d1i = w;
    const d2r = 1, d2i = w / 2;
    const dr = d1r * d2r - d1i * d2i;
    const di = d1r * d2i + d1i * d2r;
    const denom = dr * dr + di * di;
    return { re: dr / denom, im: -di / denom };
  });

  const cx = 10 + PW / 2, cy = H / 2;
  const sc = 120;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Nyquist Plot and Gain/Phase Margins — Stability in the Frequency Domain</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="nyqArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Nyquist plot */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={cx} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Nyquist Plot — G(jω) = 1/[(jω+1)(jω/2+1)]</text>

        {/* Axes */}
        <line x1={10 + 20} y1={cy} x2={10 + PW - 10} y2={cy} stroke="#ccc" strokeWidth="1.5" markerEnd="url(#nyqArr)" />
        <line x1={cx} y1={H - 20} x2={cx} y2={20} stroke="#ccc" strokeWidth="1.5" markerEnd="url(#nyqArr)" />
        <text x={10 + PW - 12} y={cy + 14} fontSize="10" fill="#888">Re</text>
        <text x={cx + 4} y={24} fontSize="10" fill="#888">Im</text>

        {/* Grid */}
        {[-1, -0.5, 0.5, 1].map(v => (
          <g key={v}>
            <line x1={cx + v * sc} y1={cy - 3} x2={cx + v * sc} y2={cy + 3} stroke="#ddd" strokeWidth="1" />
            <text x={cx + v * sc} y={cy + 13} textAnchor="middle" fontSize="9" fill="#aaa">{v}</text>
            <line x1={cx - 3} y1={cy - v * sc} x2={cx + 3} y2={cy - v * sc} stroke="#ddd" strokeWidth="1" />
            <text x={cx - 8} y={cy - v * sc + 3} textAnchor="end" fontSize="9" fill="#aaa">{v}j</text>
          </g>
        ))}

        {/* Critical point (-1, 0) */}
        <circle cx={cx - sc} cy={cy} r={5} fill="#c0392b" />
        <text x={cx - sc + 8} y={cy - 8} fontSize="10" fill="#c0392b" fontWeight="700">(−1, 0)</text>
        <text x={cx - sc + 8} y={cy + 18} fontSize="9" fill="#c0392b">Critical point</text>

        {/* Nyquist curve */}
        <polyline
          points={pts.map(({ re, im }) => `${cx + re * sc},${cy - im * sc}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="2.5"
        />
        {/* Mirror (negative frequencies) */}
        <polyline
          points={pts.map(({ re, im }) => `${cx + re * sc},${cy + im * sc}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3" opacity="0.5"
        />

        {/* ω=0 annotation */}
        <circle cx={cx + pts[0].re * sc} cy={cy - pts[0].im * sc} r={4} fill="#2E75B6" />
        <text x={cx + pts[0].re * sc + 8} y={cy - pts[0].im * sc} fontSize="10" fill="#2E75B6">ω→0  G=1∠0°</text>

        {/* ω→∞ annotation */}
        <text x={cx + 4} y={cy - 8} fontSize="9" fill="#888">ω→∞: G→0</text>

        {/* Gain margin line */}
        {(() => {
          // Find where Im=0 (phase crossover): approximately w=sqrt(2)
          const w0 = Math.sqrt(2);
          const d1r = 1, d1i = w0;
          const d2r = 1, d2i = w0 / 2;
          const dr = d1r * d2r - d1i * d2i;
          const di = d1r * d2i + d1i * d2r;
          const denom = dr * dr + di * di;
          const re0 = dr / denom;
          const x0 = cx + re0 * sc;
          return (
            <>
              <line x1={x0} y1={cy - 14} x2={x0} y2={cy + 14} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="4,3" />
              <line x1={x0} y1={cy} x2={cx - sc} y2={cy} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="4,3" />
              <text x={(x0 + cx - sc) / 2} y={cy - 8} textAnchor="middle" fontSize="9" fill="#27ae60" fontWeight="700">GM</text>
            </>
          );
        })()}

        {/* Panel 2: Margins table */}
        <rect x={PW + 40} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 40 + PW / 2} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Gain Margin & Phase Margin — Design Targets</text>

        {[
          { y: 40, title: 'Gain Margin (GM)', col: '#27ae60', bg: '#f0fff4', bc: '#27ae60', body: ['GM = 1/|G(jω_pc)|  where ∠G(jω_pc)=−180°', 'How much gain can increase before instability', 'Target: GM > 6 dB  (factor of 2 in gain)', 'Measured: distance from Nyquist to (−1,0) on real axis'] },
          { y: 140, title: 'Phase Margin (PM)', col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6', body: ['PM = 180° + ∠G(jω_gc)  where |G(jω_gc)|=1', 'How much extra phase lag before instability', 'Target: PM > 30°–60°  (45° typical)', 'Relates to damping ratio: PM ≈ 100·ζ for ζ < 0.7'] },
          { y: 248, title: 'Nyquist Criterion', col: '#c0392b', bg: '#fff5f5', bc: '#c0392b', body: ['N = P − Z   (Z = RHP closed-loop poles)', 'N = encirclements of (−1,0)  (clockwise = positive)', 'P = open-loop RHP poles', 'Stable if Z = 0 → need N = −P encirclements'] },
        ].map(({ y, title, col, bg, bc, body }) => (
          <g key={y}>
            <rect x={PW + 48} y={y} width={PW - 16} height={body.length * 18 + 24} rx={4} fill={bg} stroke={bc} strokeWidth="1.5" />
            <text x={PW + 56} y={y + 16} fontSize="12" fill={col} fontWeight="700">{title}</text>
            {body.map((line, i) => (
              <text key={i} x={PW + 56} y={y + 32 + i * 17} fontSize="10.5" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The Nyquist plot traces G(jω) in the complex plane as ω sweeps from 0 to ∞. Stability is determined by how many times the curve encircles the critical point (−1, 0). Gain margin measures how much gain increase the system can tolerate; phase margin measures how much extra phase lag it can tolerate. Both margins must be positive for a stable closed-loop system.</div>
    </div>
  );
}

// ── Diagram 6: Step & Impulse Response — Standard 2nd-Order System ─
function DiagramStepResponse() {
  const W = 900, H = 320;
  const PW = (W - 30) / 2;

  const nPts = 100;
  const tMax = 12;
  const t = Array.from({ length: nPts }, (_, i) => i / (nPts - 1) * tMax);

  // Underdamped ζ=0.3, ωn=2
  const resp = (zeta, wn) => t.map(tv => {
    if (zeta >= 1) {
      const s1 = -zeta * wn + wn * Math.sqrt(zeta * zeta - 1);
      const s2 = -zeta * wn - wn * Math.sqrt(zeta * zeta - 1);
      return 1 + (s2 * Math.exp(s1 * tv) - s1 * Math.exp(s2 * tv)) / (s1 - s2);
    }
    const wd = wn * Math.sqrt(1 - zeta * zeta);
    return 1 - Math.exp(-zeta * wn * tv) * (Math.cos(wd * tv) + (zeta / Math.sqrt(1 - zeta * zeta)) * Math.sin(wd * tv));
  });

  const cases = [
    { zeta: 0.2, wn: 2, col: '#c0392b', label: 'ζ=0.2 (underdamped)' },
    { zeta: 0.7, wn: 2, col: '#e07b00', label: 'ζ=0.7 (underdamped)' },
    { zeta: 1.0, wn: 2, col: '#2E75B6', label: 'ζ=1.0 (critically damped)' },
    { zeta: 1.8, wn: 2, col: '#27ae60', label: 'ζ=1.8 (overdamped)' },
  ];

  const ox = 10 + 28, oy = 260, ow = PW - 48, oh = 210;
  const mapPt = (tv, y) => [ox + (tv / tMax) * ow, oy - y * oh];

  // Annotations panel
  const ox2 = PW + 50, oy2 = 260, ow2 = PW - 60, oh2 = 200;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Step Response of G(s) = ωₙ² / (s² + 2ζωₙs + ωₙ²) — Effect of Damping Ratio ζ</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="srArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888" />
          </marker>
        </defs>

        {/* Panel 1: Step response curves */}
        <rect x={10} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={10 + PW / 2} y={26} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Unit Step Response — Four Damping Cases (ωₙ=2)</text>

        {/* Axes */}
        <line x1={ox} y1={oy + 6} x2={ox + ow + 14} y2={oy + 6} stroke="#888" strokeWidth="1.5" markerEnd="url(#srArr)" />
        <line x1={ox} y1={oy + 6} x2={ox} y2={oy - oh - 14} stroke="#888" strokeWidth="1.5" markerEnd="url(#srArr)" />
        <text x={ox + ow + 18} y={oy + 10} fontSize="10" fill="#555">t</text>
        <text x={ox - 14} y={oy - oh - 16} fontSize="10" fill="#555">y(t)</text>

        {/* Grid */}
        {[0, 0.5, 1, 1.5].map(v => {
          const y = oy - v * oh;
          return (
            <g key={v}>
              <line x1={ox} y1={y} x2={ox + ow} y2={y} stroke={v === 1 ? '#f0cece' : '#f5f5f5'} strokeWidth={v === 1 ? 1.5 : 1} />
              <text x={ox - 4} y={y + 4} textAnchor="end" fontSize="9" fill="#aaa">{v}</text>
            </g>
          );
        })}
        {[0, 2, 4, 6, 8, 10, 12].map(v => {
          const x = ox + (v / tMax) * ow;
          return <text key={v} x={x} y={oy + 16} textAnchor="middle" fontSize="9" fill="#aaa">{v}</text>;
        })}

        {/* Curves */}
        {cases.map(({ zeta, wn, col, label }, ci) => {
          const ys = resp(zeta, wn);
          const pts = ys.map((y, i) => mapPt(t[i], Math.min(y, 1.8)));
          return (
            <g key={ci}>
              <polyline points={pts.map(([x, y]) => `${x},${y}`).join(' ')} fill="none" stroke={col} strokeWidth="2" />
            </g>
          );
        })}

        {/* Steady-state line */}
        <line x1={ox} y1={oy - oh} x2={ox + ow} y2={oy - oh} stroke="#555" strokeWidth="1" strokeDasharray="5,3" />
        <text x={ox + ow - 4} y={oy - oh - 4} textAnchor="end" fontSize="9" fill="#555">y=1 (steady state)</text>

        {/* Legend */}
        {cases.map(({ col, label }, i) => (
          <g key={i}>
            <line x1={ox + 8} y1={H - 64 + i * 14} x2={ox + 28} y2={H - 64 + i * 14} stroke={col} strokeWidth="2" />
            <text x={ox + 32} y={H - 60 + i * 14} fontSize="9.5" fill={col}>{label}</text>
          </g>
        ))}

        {/* Panel 2: Annotations */}
        <rect x={PW + 40} y={10} width={PW} height={H - 20} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={PW + 40 + PW / 2} y={26} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Key Performance Metrics</text>

        {[
          { y: 36, col: '#c0392b', bg: '#fff5f5', bc: '#c0392b', title: 'Rise Time (tᵣ)', body: ['Time to go from 10% to 90% of final value', 'tᵣ ≈ (1.8)/ωₙ for ζ=0.7 (rule of thumb)', 'Lower ζ → faster rise BUT more overshoot'] },
          { y: 112, col: '#e07b00', bg: '#fff9e6', bc: '#e07b00', title: 'Peak Time (tₚ) & Overshoot (%OS)', body: ['tₚ = π / ωd   (ωd = ωₙ√(1−ζ²))', '%OS = 100·exp(−πζ/√(1−ζ²))', 'ζ=0.2 → ~53% OS;  ζ=0.7 → ~5% OS'] },
          { y: 196, col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6', title: 'Settling Time (tₛ)', body: ['Time to stay within ±2% of final value', 'tₛ ≈ 4 / (ζ·ωₙ)  (2% criterion)', 'Depends on ζωₙ (distance of poles from Im axis)'] },
          { y: 268, col: '#27ae60', bg: '#f0fff4', bc: '#27ae60', title: 'Design Rule', body: ['ζ = 0.6–0.8: balanced speed & overshoot', 'ωₙ sets speed; ζ sets damping character'] },
        ].map(({ y, col, bg, bc, title, body }) => (
          <g key={y}>
            <rect x={PW + 48} y={y} width={PW - 16} height={body.length * 18 + 22} rx={4} fill={bg} stroke={bc} strokeWidth="1.5" />
            <text x={PW + 56} y={y + 15} fontSize="11.5" fill={col} fontWeight="700">{title}</text>
            {body.map((line, i) => (
              <text key={i} x={PW + 56} y={y + 30 + i * 17} fontSize="10" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The standard second-order system is the fundamental building block for understanding transient performance. The natural frequency ωₙ sets the speed of response; the damping ratio ζ controls the character. Under-damped (ζ &lt; 1) systems oscillate before settling. Critically damped (ζ = 1) settles fastest without overshoot. Overdamped (ζ &gt; 1) is slow with no overshoot.</div>
    </div>
  );
}

// ── Diagram 7: PID Controller in Frequency Domain ────────────────
function DiagramPID() {
  const W = 900, H = 300;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>PID Controller — Transfer Function, Bode Interpretation, and Tuning Rules</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        <defs>
          <marker id="pidArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" />
          </marker>
        </defs>

        {/* PID structure */}
        <text x={W / 2} y={22} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">C(s) = Kₚ + Kᵢ/s + Kd·s = Kₚ[1 + 1/(Tᵢs) + Td·s]</text>

        {/* Three parallel branches */}
        {/* Input line */}
        <line x1={20} y1={155} x2={80} y2={155} stroke="#c0392b" strokeWidth="2" markerEnd="url(#pidArr)" />
        <text x={10} y={151} fontSize="11" fill="#555">E(s)</text>

        {/* Branch split */}
        <line x1={80} y1={75} x2={80} y2={235} stroke="#c0392b" strokeWidth="1.5" />
        {/* P branch */}
        <line x1={80} y1={75} x2={140} y2={75} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#pidArr)" />
        <rect x={140} y={55} width={120} height={40} rx={4} fill="#fff5f5" stroke="#c0392b" strokeWidth="2" />
        <text x={200} y={78} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Kₚ</text>
        <text x={200} y={90} textAnchor="middle" fontSize="9" fill="#c0392b">Proportional</text>
        <line x1={260} y1={75} x2={370} y2={75} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#pidArr)" />

        {/* I branch */}
        <line x1={80} y1={155} x2={140} y2={155} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#pidArr)" />
        <rect x={140} y={135} width={120} height={40} rx={4} fill="#fff5f5" stroke="#2E75B6" strokeWidth="2" />
        <text x={200} y={158} textAnchor="middle" fontSize="13" fill="#2E75B6" fontWeight="700">Kᵢ / s</text>
        <text x={200} y={170} textAnchor="middle" fontSize="9" fill="#2E75B6">Integral</text>
        <line x1={260} y1={155} x2={370} y2={155} stroke="#2E75B6" strokeWidth="1.5" markerEnd="url(#pidArr)" />

        {/* D branch */}
        <line x1={80} y1={235} x2={140} y2={235} stroke="#c0392b" strokeWidth="1.5" markerEnd="url(#pidArr)" />
        <rect x={140} y={215} width={120} height={40} rx={4} fill="#fff5f5" stroke="#27ae60" strokeWidth="2" />
        <text x={200} y={238} textAnchor="middle" fontSize="13" fill="#27ae60" fontWeight="700">Kd · s</text>
        <text x={200} y={250} textAnchor="middle" fontSize="9" fill="#27ae60">Derivative</text>
        <line x1={260} y1={235} x2={370} y2={235} stroke="#27ae60" strokeWidth="1.5" markerEnd="url(#pidArr)" />

        {/* Summing junction */}
        <line x1={370} y1={75} x2={370} y2={235} stroke="#c0392b" strokeWidth="1.5" />
        <circle cx={410} cy={155} r={14} fill="#fff" stroke="#c0392b" strokeWidth="2" />
        <text x={410} y={160} textAnchor="middle" fontSize="14" fill="#c0392b" fontWeight="700">Σ</text>
        <line x1={370} y1={155} x2={394} y2={155} stroke="#c0392b" strokeWidth="1.5" />
        <line x1={424} y1={155} x2={470} y2={155} stroke="#c0392b" strokeWidth="2" markerEnd="url(#pidArr)" />
        <text x={474} y={151} fontSize="11" fill="#555">U(s)</text>

        {/* Right panel: Frequency effects */}
        <rect x={500} y={18} width={390} height={H - 26} rx={5} fill="#fff" stroke="#f0cece" />
        <text x={695} y={36} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Frequency-Domain Effect of Each Term</text>

        {[
          { y: 46, col: '#c0392b', bg: '#fff5f5', bc: '#c0392b', title: 'P — Proportional (Kₚ)', lines: ['Flat gain: adds Kₚ dB across all frequencies', 'Increases loop gain → reduces steady-state error', 'Alone: cannot eliminate steady-state error for step'] },
          { y: 114, col: '#2E75B6', bg: '#eaf3ff', bc: '#2E75B6', title: 'I — Integral (Kᵢ/s)', lines: ['Adds a pole at origin (−20 dB/dec, −90° phase)', 'Infinite DC gain → zero steady-state error for step/ramp', 'Danger: phase lag destabilises system (reduces PM)'] },
          { y: 182, col: '#27ae60', bg: '#f0fff4', bc: '#27ae60', title: 'D — Derivative (Kd·s)', lines: ['Adds a zero at origin (+20 dB/dec, +90° phase)', 'Phase lead: boosts phase margin, improves stability', 'Amplifies high-freq noise — often filtered: Kd·s/(τ_f·s+1)'] },
          { y: 250, col: '#e07b00', bg: '#fff9e6', bc: '#e07b00', title: 'Ziegler-Nichols Tuning (freq. method)', lines: ['Find ultimate gain Kᵤ and period Tᵤ at oscillation', 'PID: Kₚ=0.6Kᵤ, Tᵢ=0.5Tᵤ, Td=0.125Tᵤ'] },
        ].map(({ y, col, bg, bc, title, lines }) => (
          <g key={y}>
            <rect x={508} y={y} width={374} height={lines.length * 16 + 24} rx={3} fill={bg} stroke={bc} strokeWidth="1" />
            <text x={516} y={y + 15} fontSize="11" fill={col} fontWeight="700">{title}</text>
            {lines.map((line, i) => (
              <text key={i} x={516} y={y + 29 + i * 16} fontSize="10" fill="#333">{line}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>In the frequency domain, each PID term has a clear physical interpretation. The integral term adds a pole at s = 0, guaranteeing zero steady-state error but costing 90° of phase. The derivative term adds a zero, contributing phase lead that improves stability margins. PID design in the frequency domain amounts to shaping the loop gain magnitude and phase to meet gain/phase margin specifications.</div>
    </div>
  );
}

// ── Diagram 8: Common Transfer Functions Table ────────────────────
function DiagramCommonTFs() {
  const W = 900, H = 340;
  const rows = [
    { name: 'Integrator', tf: '1/s', mag: 'Slope −20 dB/dec always', phase: '−90° always', time: 'Ramp output for step input', poles: 's=0 (origin)' },
    { name: 'Differentiator', tf: 's', mag: '+20 dB/dec always', phase: '+90° always', time: 'Impulse out for step in', poles: 'Zero at origin' },
    { name: '1st-order lag', tf: '1/(τs+1)', mag: '0→ −20 dB/dec at ω=1/τ', phase: '0° → −90°', time: 'Exp. rise; τ=63% time', poles: 's=−1/τ' },
    { name: '1st-order lead', tf: '(τs+1)', mag: '0→ +20 dB/dec at ω=1/τ', phase: '0° → +90°', time: 'Differentiating character', poles: 'Zero s=−1/τ' },
    { name: '2nd-order underdamped', tf: 'ωₙ²/(s²+2ζωₙs+ωₙ²)', mag: 'Resonant peak at ωₙ√(1−2ζ²)', phase: '0° → −180°', time: 'Oscillatory step response', poles: 'Complex conjugate pair' },
    { name: 'Pure time delay', tf: 'e^(−Ls)', mag: 'Flat (0 dB always)', phase: '−Lω (unbounded)', time: 'Exact copy delayed by L', poles: 'Infinite in RHP — irrational TF' },
    { name: 'Proportional (P)', tf: 'Kₚ', mag: 'Flat at 20log(Kₚ)', phase: '0°', time: 'Scaled copy of input', poles: 'None' },
    { name: 'PI controller', tf: 'Kₚ(1+1/Tᵢs)', mag: 'Rise below 1/Tᵢ, flat above', phase: '−90°→0°', time: 'Eliminates step SS error', poles: 's=0, zero at s=−1/Tᵢ' },
  ];

  const cols = ['System', 'G(s)', 'Bode Mag', 'Bode Phase', 'Time-Domain', 'Poles/Zeros'];
  const colW = [110, 150, 140, 110, 155, 170];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Common Transfer Functions — Quick Reference</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', display: 'block' }}>
        {/* Header */}
        {cols.map((col, i) => {
          const x = colW.slice(0, i).reduce((a, b) => a + b, 8);
          return (
            <g key={i}>
              <rect x={x} y={8} width={colW[i] - 2} height={24} fill="#c0392b" />
              <text x={x + 6} y={24} fontSize="10.5" fill="#fff" fontWeight="700">{col}</text>
            </g>
          );
        })}
        {/* Rows */}
        {rows.map((row, ri) => {
          const y = 34 + ri * 37;
          const vals = [row.name, row.tf, row.mag, row.phase, row.time, row.poles];
          const bg = ri % 2 === 0 ? '#fff5f5' : '#fff';
          return (
            <g key={ri}>
              {vals.map((val, ci) => {
                const x = colW.slice(0, ci).reduce((a, b) => a + b, 8);
                return (
                  <g key={ci}>
                    <rect x={x} y={y} width={colW[ci] - 2} height={35} fill={ci === 0 ? '#FEF0F0' : bg} stroke="#f0cece" strokeWidth="0.5" />
                    {val.split('\n').map((line, li) => (
                      <text key={li} x={x + 5} y={y + 13 + li * 13} fontSize={ci === 1 ? '10' : '9.5'} fill={ci === 0 ? '#7B0D0D' : '#333'} fontWeight={ci === 0 ? '700' : '400'} fontFamily={ci === 1 ? "'Courier New',monospace" : 'inherit'}>{line}</text>
                    ))}
                  </g>
                );
              })}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>A reference table of the most important transfer functions encountered in control engineering and system dynamics. Each entry shows the Laplace transfer function, its Bode magnitude and phase behaviour, the corresponding time-domain character, and the location of its poles and zeros in the s-plane.</div>
    </div>
  );
}

// ── Main ──────────────────────────────────────────────────────────
export default function TransferFunctions() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Transfer Functions &amp; Frequency Domain</h1>
      <p style={S.p}>
        Transfer functions are the language of linear systems analysis. By applying the Laplace transform, the differential equations that govern a continuous dynamic system are converted into algebraic relationships between input and output in the complex frequency domain. This transformation makes it possible to analyse stability, predict transient response, and design controllers using powerful graphical tools — Bode plots, Nyquist diagrams, pole-zero maps — without solving differential equations directly in time. The frequency domain also reveals how systems respond to sinusoidal inputs of every frequency, which is fundamental to understanding filtering, resonance, and bandwidth.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "The Laplace transform converts ODEs into algebraic equations: differentiation → ×s, integration → ÷s",
        "A transfer function G(s) = Y(s)/U(s) = N(s)/D(s) fully characterises a linear time-invariant (LTI) system",
        "Poles are roots of D(s): they determine stability and transient behaviour",
        "Zeros are roots of N(s): they shape the frequency distribution of the response",
        "Stability requires ALL poles in the left half of the s-plane (Re(s) < 0)",
        "Bode plots show magnitude (dB) and phase vs. frequency on log scales — easy to sketch asymptotically",
        "The Nyquist criterion uses the G(jω) curve to determine closed-loop stability from open-loop data",
        "Gain margin and phase margin quantify how far a system is from instability — design targets: GM > 6 dB, PM > 30–60°",
        "The standard 2nd-order system characterises transient response via natural frequency ωₙ and damping ratio ζ",
        "PID controllers shape the loop's frequency response: I adds phase lag (DC precision), D adds phase lead (stability)",
      ]} />

      <h2 style={S.h2}>The Laplace Transform</h2>
      <p style={S.p}>
        The Laplace transform maps a time-domain signal f(t) to a function F(s) of the complex variable s = σ + jω. The power of this transformation is that it converts the calculus operations of differentiation and integration into multiplication and division by s — turning systems of ODEs into systems of algebraic equations that are far easier to manipulate.
      </p>
      <DiagramLaplace />
      <Table2 rows={[
        ["Definition", "F(s) = L{f(t)} = ∫₀^∞ f(t)·e⁻ˢᵗ dt\ns = σ + jω  (complex frequency, σ = real, ω = imaginary part)"],
        ["Differentiation property", "L{df/dt} = sF(s) − f(0⁻)\nL{d²f/dt²} = s²F(s) − sf(0⁻) − f'(0⁻)\nInitial conditions appear naturally — no need to handle separately"],
        ["Integration property", "L{∫f(t)dt} = F(s)/s\nA stock (integrator) in time domain ↔ division by s in s-domain"],
        ["Final Value Theorem", "lim t→∞ f(t) = lim s→0 sF(s)   (if limit exists)\nFinds steady-state value without inverting the transform"],
        ["Initial Value Theorem", "lim t→0⁺ f(t) = lim s→∞ sF(s)\nFinds the initial instantaneous response"],
        ["Common pairs", "δ(t) ↔ 1\nu(t) ↔ 1/s\ne⁻ᵃᵗ ↔ 1/(s+a)\nsin(ωt) ↔ ω/(s²+ω²)\ncos(ωt) ↔ s/(s²+ω²)\nte⁻ᵃᵗ ↔ 1/(s+a)²"],
        ["Convolution theorem", "L{f₁(t)*f₂(t)} = F₁(s)·F₂(s)\nConvolution in time → multiplication in s-domain\nThis is why series blocks simply multiply their TFs"],
        ["Region of convergence", "F(s) converges where Re(s) > σ_max (largest real pole)\nFor stable systems, σ_max < 0 so jω axis is in ROC → Fourier transform exists"],
      ]} />

      <h2 style={S.h2}>Transfer Functions and Block Diagrams</h2>
      <p style={S.p}>
        A transfer function G(s) = N(s)/D(s) is the ratio of the Laplace transform of the output to the Laplace transform of the input, assuming zero initial conditions. It is a complete description of a linear, time-invariant system's input-output behaviour. Block diagrams provide a graphical notation for interconnected transfer functions and can be algebraically reduced to a single equivalent transfer function.
      </p>
      <DiagramBlockDiagram />
      <Table2 rows={[
        ["Transfer function", "G(s) = Y(s)/U(s) = (bₘsᵐ + … + b₀)/(aₙsⁿ + … + a₀)\nProper: m ≤ n (physically realisable — output can't anticipate input)\nStrictly proper: m < n (most physical systems)"],
        ["Poles", "Values of s where |G(s)| → ∞; roots of denominator D(s)\nDetermine the natural frequencies of the unforced system\nEach pole contributes a term eˢⁱᵗ to the time-domain response"],
        ["Zeros", "Values of s where G(s) = 0; roots of numerator N(s)\nBlock certain frequencies from reaching the output\nRight-half-plane zeros cause non-minimum phase behaviour (initial undershoot)"],
        ["Series (cascade)", "G_total(s) = G₁(s)·G₂(s)·… ·Gₙ(s)\nMagnitudes multiply (add in dB); phases add"],
        ["Parallel", "G_total(s) = G₁(s) + G₂(s) + …\nDirect addition of transfer functions"],
        ["Closed-loop (unity feedback)", "T(s) = G(s) / [1 + G(s)]\nCharacteristic equation: 1 + G(s) = 0 → roots are closed-loop poles"],
        ["Closed-loop (with H(s))", "T(s) = G(s) / [1 + G(s)H(s)]\nH(s) = sensor/measurement transfer function"],
        ["Sensitivity function", "S(s) = 1/[1+GC] — how disturbances affect output\nComplementary: T(s) = GC/[1+GC];  S+T = 1 always"],
      ]} />

      <h2 style={S.h2}>Poles, Zeros, and the s-Plane</h2>
      <p style={S.p}>
        The pole-zero map is the single most informative summary of a linear system's behaviour. It immediately reveals stability (are all poles in the left half-plane?), the character of the transient response (oscillatory? over-damped?), and the frequency shaping introduced by zeros.
      </p>
      <DiagramPoleZero />
      <Table2 rows={[
        ["Stability rule", "All poles must have Re(s) < 0 for BIBO stability\nOne or more poles with Re(s) > 0 → unstable (growing exponentials)\nPoles on jω axis (Re=0) → marginally stable (sustained oscillations)"],
        ["Real poles", "s = −a (a > 0): contributes decaying exponential e⁻ᵃᵗ\nFaster decay with larger a (pole further left)\nPhysical meaning: first-order time constant τ = 1/a"],
        ["Complex conjugate poles", "s = −σ ± jωd: contributes damped sinusoid e⁻σᵗ·cos(ωd·t+φ)\nOscillation frequency = ωd; decay rate = σ\nImaginary part gives oscillation; real part gives damping"],
        ["RHP zeros", "Non-minimum phase: zeros in right half-plane (Re > 0)\nCauses initial response in wrong direction (undershoot) before correcting\nSeverely limits achievable bandwidth — common in flexible structures, robotics"],
        ["Dominant poles", "The pole(s) closest to the jω axis dominate the long-term transient\nFar-left poles decay quickly and can often be neglected\nModel order reduction: keep only dominant poles"],
        ["Routh-Hurwitz criterion", "Algebraic test for stability without computing roots\nForm Routh array from characteristic polynomial coefficients\nAll elements in left column positive → all poles in LHP → stable"],
        ["Damping ratio from poles", "Pole at s = −ζωₙ ± jωₙ√(1−ζ²)\nζ = cos(θ) where θ is angle of pole from negative real axis\nLines of constant ζ are radial lines from origin in s-plane"],
      ]} />

      <h2 style={S.h2}>Bode Plots — Frequency Response</h2>
      <p style={S.p}>
        A Bode plot represents the frequency response G(jω) — obtained by substituting s = jω — as two separate plots: magnitude in decibels and phase in degrees, both vs. frequency on a logarithmic scale. Bode plots are the workhorse of frequency-domain design because they can be sketched by hand using straight-line asymptotes, and system components in series simply add their individual Bode plots.
      </p>
      <DiagramBode />
      <Table2 rows={[
        ["Frequency response", "G(jω) = G(s)|_{s=jω}\nEvaluate TF on imaginary axis only\nValid for stable systems (jω axis is in region of convergence)"],
        ["Magnitude in dB", "|G(jω)|_dB = 20·log₁₀|G(jω)|\nSeries systems: magnitudes add in dB (multiply linearly)\nDecibel scale: 0 dB = unity gain, +20 dB = ×10, −20 dB = ÷10"],
        ["Phase in degrees", "∠G(jω) = atan2(Im, Re) of G(jω)\nSeries systems: phases add directly\nA total phase shift of −180° at unit gain → instability boundary"],
        ["Corner frequency", "ω_c = 1/τ for a first-order factor (τs+1)\nMagnitude transitions from 0 dB/dec to −20 dB/dec\nPhase transitions from 0° to −90°, centred at ω_c"],
        ["Slope rules", "Each real pole: −20 dB/dec slope, −90° total phase\nEach real zero: +20 dB/dec, +90°\nEach complex pair of poles: −40 dB/dec, −180° total\nIntegrator (1/s): −20 dB/dec starting from DC, −90° constant"],
        ["Bandwidth", "Frequency where |G(jω)| drops to −3 dB (≈ 0.707 of DC gain)\nHigher bandwidth → faster time-domain response\nBandwidth ≈ ωₙ for underdamped second-order systems"],
        ["Resonant peak Mₚ", "For 2nd-order: Mₚ = 1/(2ζ√(1−ζ²)) at ω = ωₙ√(1−2ζ²)\nOccurs only for ζ < 0.707; peak → ∞ as ζ → 0\nRelates to closed-loop overshoot"],
        ["Sketching asymptotes", "Start at DC gain; add ±20 dB/dec slope at each corner frequency\nSum all contributions from each pole and zero\nExact curve deviates ≤ 3 dB from asymptote at corner frequencies"],
      ]} />

      <h2 style={S.h2}>Nyquist Plot and Stability Margins</h2>
      <p style={S.p}>
        While the Bode plot separates magnitude and phase, the Nyquist plot traces G(jω) as a single curve in the complex plane. The Nyquist stability criterion provides a rigorous test for closed-loop stability based on the open-loop frequency response — crucially, it works even when G(s) has open-loop unstable poles.
      </p>
      <DiagramNyquist />
      <Table2 rows={[
        ["Nyquist criterion", "Z = P − N\nZ = number of closed-loop RHP poles (want Z = 0)\nP = number of open-loop RHP poles\nN = number of clockwise encirclements of (−1, 0)\nFor open-loop stable system (P=0): stable iff N=0"],
        ["Gain crossover freq ω_gc", "Frequency where |G(jω_gc)| = 1 (0 dB)\nThe frequency at which the Nyquist curve crosses the unit circle\nPhase margin measured here"],
        ["Phase crossover freq ω_pc", "Frequency where ∠G(jω_pc) = −180°\nThe frequency at which the Nyquist curve crosses the negative real axis\nGain margin measured here"],
        ["Gain margin (GM)", "GM = 1/|G(jω_pc)|  in linear; 20log(1/|G(jω_pc)|) in dB\nAmount gain can increase before instability\nTarget: GM > 6 dB; GM < 0 dB → already unstable"],
        ["Phase margin (PM)", "PM = 180° + ∠G(jω_gc)\nAmount of extra phase lag tolerable before instability\nTarget: PM > 30°; PM ≈ 45°–60° typical\nPM ≈ 100ζ (degrees) for second-order systems (ζ < 0.7)"],
        ["Conditional stability", "Some systems: stable at normal gain, unstable at very low or high gain\nNyquist curve encircles (−1,0) twice — requires careful gain range analysis"],
        ["Nichols chart", "Combines Bode magnitude and phase into a single plane\nClosed-loop magnitude contours overlaid — reads off closed-loop frequency response\nUseful for quickly reading closed-loop resonant peak and bandwidth"],
      ]} />

      <h2 style={S.h2}>Second-Order System Response</h2>
      <p style={S.p}>
        The standard second-order transfer function G(s) = ωₙ²/(s² + 2ζωₙs + ωₙ²) is arguably the most important prototype in all of control engineering. Every performance specification — rise time, overshoot, settling time — can be expressed in terms of just two parameters: the natural frequency ωₙ and the damping ratio ζ.
      </p>
      <DiagramStepResponse />
      <Table2 rows={[
        ["Natural frequency ωₙ", "The frequency of oscillation if there were no damping (ζ=0)\nSets the speed scale of the entire response\nUnits: rad/s; related to pole magnitude |p| = ωₙ"],
        ["Damping ratio ζ", "ζ < 1: underdamped (oscillatory)\nζ = 1: critically damped (fastest non-oscillatory)\nζ > 1: overdamped (sluggish, no oscillation)\nζ = 0: undamped (pure sinusoidal oscillation forever)"],
        ["Characteristic equation", "s² + 2ζωₙs + ωₙ² = 0\nRoots: s = −ζωₙ ± jωₙ√(1−ζ²)\nDamped natural frequency: ωd = ωₙ√(1−ζ²)"],
        ["Rise time tᵣ", "tᵣ ≈ (1 − 0.4169ζ + 2.917ζ²)/ωₙ\nApproximately: tᵣ ≈ 1.8/ωₙ for ζ ≈ 0.7\nSmaller ωₙ or ζ → faster rise (at cost of more overshoot)"],
        ["Peak time tₚ", "tₚ = π/ωd = π/(ωₙ√(1−ζ²))\nTime to reach first peak of step response"],
        ["Percent overshoot %OS", "%OS = 100·exp(−πζ/√(1−ζ²))\nζ=0.1 → 73%; ζ=0.5 → 16%; ζ=0.7 → 5%; ζ=1 → 0%\nInversely related to phase margin: PM ≈ 100ζ"],
        ["Settling time tₛ", "tₛ ≈ 4/(ζωₙ)  for ±2% criterion\ntₛ ≈ 3/(ζωₙ)  for ±5% criterion\nDepends on σ = ζωₙ: real part of dominant poles"],
        ["Frequency-domain metrics", "Bandwidth ωBW ≈ ωₙ√(1−2ζ²+√(4ζ⁴−4ζ²+2))\nResonant peak: Mₚ = 1/(2ζ√(1−ζ²))  for ζ < 0.707\nResonant frequency: ωᵣ = ωₙ√(1−2ζ²)"],
      ]} />

      <h2 style={S.h2}>PID Controllers in the Frequency Domain</h2>
      <p style={S.p}>
        The PID controller is the most widely used controller in industrial practice. Its three terms — proportional, integral, and derivative — each have a clear and distinct interpretation in the frequency domain, making Bode-plot-based design both intuitive and powerful.
      </p>
      <DiagramPID />
      <Table2 rows={[
        ["PID transfer function", "C(s) = Kₚ + Kᵢ/s + Kd·s = Kₚ[1 + 1/(Tᵢs) + Td·s]\nTᵢ = Kₚ/Kᵢ (integral time);  Td = Kd/Kₚ (derivative time)\nIncludes a pole at origin (from I) and a zero pair (from PI+D combination)"],
        ["Ideal PID zeros", "C(s) = Kd(s² + (Kₚ/Kd)s + Kᵢ/Kd)/s\nTwo zeros can be placed to cancel or reshape plant poles\nZero placement: s = −Kₚ/(2Kd) ± √((Kₚ/2Kd)² − Kᵢ/Kd)"],
        ["Phase lead from D", "Derivative term contributes up to +90° of phase lead\nBoosts phase margin near gain crossover → improves damping\nPractical: filtered derivative C_D = Kd·s/(τ_f·s+1), τ_f = Td/N, N=5–20"],
        ["Steady-state error", "Type 0 plant + P only: finite error to step\nType 0 plant + I: zero error to step, finite error to ramp\nType 0 + PI: zero step error; Type 1 + PI: zero ramp error"],
        ["Ziegler-Nichols (step)", "Measure process reaction rate R and lag L from step test\nP: Kₚ=1/(RL);  PI: Kₚ=0.9/(RL), Tᵢ=L/0.3\nPID: Kₚ=1.2/(RL), Tᵢ=2L, Td=0.5L"],
        ["Ziegler-Nichols (freq.)", "Increase gain until sustained oscillation: record Kᵤ and Tᵤ\nP: Kₚ=0.5Kᵤ;  PI: Kₚ=0.45Kᵤ, Tᵢ=0.85Tᵤ\nPID: Kₚ=0.6Kᵤ, Tᵢ=0.5Tᵤ, Td=0.125Tᵤ"],
        ["IMC / lambda tuning", "Internal Model Control: C(s) = G⁻¹(s)·λ/(s+λ)\nλ = desired closed-loop bandwidth (1/desired τ_cl)\nRobust and intuitive — single tuning parameter λ"],
        ["Anti-windup", "Integrator 'winds up' when output is saturated — causes large overshoot on unsaturation\nAnti-windup: back-calculate or clamp integrator state when output saturates"],
      ]} />

      <h2 style={S.h2}>Common Transfer Functions — Quick Reference</h2>
      <p style={S.p}>
        The following table summarises the most frequently encountered transfer functions, connecting their algebraic form, Bode plot behaviour, and time-domain character in a single view.
      </p>
      <DiagramCommonTFs />

      <h2 style={S.h2}>Frequency Domain vs. Time Domain — Key Correspondences</h2>
      <Table2 rows={[
        ["Bandwidth ↔ rise time", "ωBW · tᵣ ≈ 1.8  (rough rule of thumb for 2nd-order systems)\nHigher bandwidth → faster rise time → more demanding control effort"],
        ["Resonant peak ↔ overshoot", "High Mₚ in Bode ↔ high %OS in step response\nBoth caused by low damping (small ζ or small PM)"],
        ["Phase margin ↔ damping ratio", "PM ≈ 100ζ (degrees) for 2nd-order dominant-pole systems\nPM=60° → ζ≈0.6 → %OS≈10%  (practical design target)"],
        ["Gain crossover ↔ settling speed", "Higher ω_gc → faster closed-loop response\nLimited by plant dynamics, RHP zeros, and time delays"],
        ["Time delay ↔ phase margin", "Delay L adds phase −Lω at each frequency\nDelay erodes PM: ΔPM = −L·ω_gc·(180/π) degrees\nSmaller gain crossover needed when delay is large"],
        ["Steady-state ↔ low-frequency gain", "DC gain = lim s→0 G(s) determines steady-state amplitude for step input\nHigh low-frequency loop gain → small steady-state error"],
        ["Model uncertainty ↔ margins", "Robust stability: system stays stable despite gain/phase uncertainty\nSmall GM and PM mean sensitivity to model errors — fragile design\nStability radius: minimum perturbation ΔG(jω) to destabilise"],
      ]} />

      <h2 style={S.h2}>Root Locus Method</h2>
      <p style={S.p}>
        The root locus is a graphical method showing how closed-loop poles move in the s-plane as a parameter (usually loop gain K) is varied from 0 to ∞. It bridges the time-domain (pole locations) and frequency-domain (Bode/Nyquist) perspectives and is especially useful for controller design.
      </p>
      <Table2 rows={[
        ["Definition", "Plot of all closed-loop poles as K varies: 1 + K·G(s)H(s) = 0\nLocus starts at open-loop poles (K=0) and ends at open-loop zeros (K→∞)\nBranches that go to ∞ follow asymptotes"],
        ["Angle condition", "∠G(s)H(s) = ±180°(2k+1) for any point s on the locus\nUsed to test whether a candidate s point is on the locus"],
        ["Asymptotes", "Number of asymptotes = n − m  (poles minus zeros)\nAngles: (2k+1)·180°/(n−m);  Centroid: σ_a = (Σpoles − Σzeros)/(n−m)"],
        ["Breakaway/break-in points", "Points where locus leaves or enters the real axis\nFound by: dK/ds = 0 where K = −1/GH along real axis"],
        ["jω-axis crossings", "Where closed-loop poles become purely imaginary → marginal stability\nFound by Routh criterion or substituting s=jω into char. equation"],
        ["Gain selection", "Pick a point on the locus with desired damping ratio ζ (radial line)\nGain K = 1/|G(s*)H(s*)| where s* is the selected closed-loop pole"],
        ["Compensator design", "Lead compensator: adds zero to left of pole → moves locus left → improves PM\nLag compensator: increases low-freq gain → reduces steady-state error without affecting PM much"],
      ]} />

      <InfoBox title="Key Formulae Summary" items={[
        "Laplace transform: F(s) = ∫₀^∞ f(t)·e⁻ˢᵗ dt;   L{df/dt} = sF(s) − f(0);   L{∫f dt} = F(s)/s",
        "Transfer function: G(s) = Y(s)/U(s) = N(s)/D(s)   (zero initial conditions)",
        "Closed-loop TF: T(s) = C(s)G(s) / [1 + C(s)G(s)H(s)]",
        "2nd-order poles: s = −ζωₙ ± jωₙ√(1−ζ²);   %OS = 100·e^(−πζ/√(1−ζ²));   tₛ ≈ 4/(ζωₙ)",
        "Bode magnitude: 20log|G(jω)| dB;   Corner at ω = 1/τ;   Slope −20n dB/dec for n poles",
        "Phase margin: PM = 180° + ∠G(jω_gc);   Gain margin: GM = −20log|G(jω_pc)| dB",
        "PID: C(s) = Kₚ + Kᵢ/s + Kd·s;   Ziegler-Nichols: Kₚ=0.6Kᵤ, Tᵢ=0.5Tᵤ, Td=0.125Tᵤ",
        "Nyquist: Z = P − N;   Root locus: starts at OL poles, ends at OL zeros; n−m asymptotes",
      ]} />
    </div>
  );
}